import React from "react";

import { useStyles } from "./User.style";
import clsx from "clsx";
import { Grid, Paper } from "@material-ui/core";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-duotone-svg-icons";
import SquareChip from "../../SquareChip"

const ValidationAccountAudit = ({ onDrawer, username, action, date, payload , ...props}) => {
  const classes = useStyles();
  const _payload = JSON.parse(props?.history?.payload) ?? null;
  const getActionLabel = () => {
    switch (action) {
      case "add":
        return "Created";
      case "edit":
        return "Edited";
      case "delete":
        return "Deleted";
      case "login":
        return "Log In";
      case "logout":
        return "Log Out";
      case "context switch in":
        return "Log In";
      case "context switch out":
        return "Log Out";
      default:
        return action;
    }
  };
   const getDetailLabel = () => {
    switch (action) {
      case "add":
         return (
        <>
          <div>{_payload?.userInfo?.Email ?? ''}</div>
          <div>{`${_payload?.userInfo?.FirstName ?? ''} ${_payload?.userInfo?.LastName ?? ''}`.trim()}</div>
        </>
      );
      case "edit":     
      case "delete":       
      case "login":      
      case "logout":     
      case "context switch in":       
      case "context switch out":      
      default:
        return "";
    }
  };

  return (
    <>
      <tr>
        <td data-column="Area" className={clsx([classes.tdc])}><SquareChip size="small" color="primary" text="Validation Account"/></td>
        <td data-column="Date" className={clsx([classes.tdc])}>{date}</td>
        <td data-column="User" className={clsx([classes.tdc])}>
          <div>{username}</div>
        </td>
        <td data-column="Action" className={clsx([classes.tdc])}>
          <div>{getActionLabel()}</div>
        </td>
        <td data-column="Details"  className={clsx([classes.tdc,classes.details])}>
          <div>{getDetailLabel()}</div>
        </td>
      </tr>
    </>
  );
};

export default ValidationAccountAudit;
